import { COLORS } from './colors';
import { LAYOUT } from './layout';
import { TYPOGRAPHY } from './typography';

export interface ITheme {
  colors: typeof COLORS;
  layout: typeof LAYOUT;
  typography: typeof TYPOGRAPHY;
}

export interface IThemeProvider {
  theme: ITheme;
}

export const THEME: ITheme = {
  colors: COLORS,
  layout: LAYOUT,
  typography: TYPOGRAPHY,
};
